<main>
    <form [formGroup]="form">
        <div>
            <p class="title mb-1">Indique em quais datas você não estará disponível</p>
            <span class="option-label-1">Ao bloquear esse período, as consultas e os eventos pessoais já criados não serão eliminados</span>
        </div>
        <div class="agendamento-container mt-5">
            <div  class="pl-4 pr-4">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16 3V7M8 3V7M4 11H20M11 15H12V18M4 7C4 6.46957 4.21071 5.96086 4.58579 5.58579C4.96086 5.21071 5.46957 5 6 5H18C18.5304 5 19.0391 5.21071 19.4142 5.58579C19.7893 5.96086 20 6.46957 20 7V19C20 19.5304 19.7893 20.0391 19.4142 20.4142C19.0391 20.7893 18.5304 21 18 21H6C5.46957 21 4.96086 20.7893 4.58579 20.4142C4.21071 20.0391 4 19.5304 4 19V7Z" stroke="#FF8321" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
            <div  class="pl-4 pr-4">
               <p>01/02/2024</p>
               <p>09:00 - 09:20</p>
            </div>
            <div  class="pl-4 pr-4">
               <p class="doctor-name">Maria Lourdes de Paula</p>
               <p>Particular primeira consulta Coloproctologia </p>
            </div>
        </div>
        <div class="agendamento-container mt-3">
            <div  class="pl-4 pr-4">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16 3V7M8 3V7M4 11H20M11 15H12V18M4 7C4 6.46957 4.21071 5.96086 4.58579 5.58579C4.96086 5.21071 5.46957 5 6 5H18C18.5304 5 19.0391 5.21071 19.4142 5.58579C19.7893 5.96086 20 6.46957 20 7V19C20 19.5304 19.7893 20.0391 19.4142 20.4142C19.0391 20.7893 18.5304 21 18 21H6C5.46957 21 4.96086 20.7893 4.58579 20.4142C4.21071 20.0391 4 19.5304 4 19V7Z" stroke="#FF8321" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
            <div  class="pl-4 pr-4">
               <p>01/02/2024</p>
               <p>09:00 - 09:20</p>
            </div>
            <div  class="pl-4 pr-4">
               <p class="doctor-name">Maria Lourdes de Paula</p>
               <p>Particular primeira consulta Coloproctologia </p>
            </div>
        </div>
        <div class="line mt-5 mb-5"></div>
        <div class="mt-5 w-full flex align-items-center" style="text-align: left;">
            <span class="p-float-label mr-3">
                <p-calendar styleClass="w-25rem custom-calendar-input" [showIcon]="true"></p-calendar>
                <label for="data">Data de inicio</label>
            </span>
            <div>
                <span class="p-float-label mr-3">
                    <p-calendar styleClass="w-25rem custom-calendar-input" [showIcon]="true"></p-calendar>
                    <label for="data">Data de finalização</label>
                </span>
            </div>
            <div class="pl-3 pr-3 flex align-items-center justify-content-center flex-1">
                <div class="mt-2 mr-2">
                    <p-inputSwitch></p-inputSwitch>
                </div>
                <div>Todo o dia</div>
            </div>
        </div>
        <div class="mt-5">
            <span class="p-float-label w-full">
                <input pInputText class="w-full" />
                <label for="data">Nome do Bloqueio</label>
            </span>
        </div>
        <div class="mt-5 chose-time p-2 pr-5 pl-5 pb-5">
            <div>
                <p>10:40 - 12-20</p>
            </div>
            <div>
                <p class="pb-0 mb-2">Horáro de inicio e fim :</p>
            </div>
            <div class="flex align-items-center">
                <div class="mr-4">
                    <p-dropdown 
                    styleClass="w-full custom-dropdown"
                    [ngModelOptions]="{standalone: true}" 
                    [(ngModel)]="hora1" 
                    [options]="['10:40','12:00','13:00','14:00']" 
                    styleClass="w-10rem" 
                    inputId="hora"
                    >
                        <ng-template let-item pTemplate="selectedItem">
                            <i class="bi bi-clock custom-dropdown-icon mr-2 ml-1"></i>
                            {{item}}
                        </ng-template>
                    </p-dropdown>
                </div>
                <div>
                    <p-dropdown 
                    styleClass="w-full custom-dropdown"
                    [ngModelOptions]="{standalone: true}" 
                    [(ngModel)]="hora2" 
                    [options]="['12:00','12:20','13:00','14:00']" 
                    styleClass="w-10rem" 
                    inputId="hora"
                    >
                    
                        <ng-template let-item pTemplate="selectedItem">
                            <i class="bi bi-clock custom-dropdown-icon mr-2 ml-1"></i>
                            {{item}}
                        </ng-template>
                        
                    </p-dropdown>
                </div>
                <div class="ml-5">
                    <span class="option-label-1 underline">Personalizado</span>
                </div>
            </div>
        </div>
    </form>
    <div class="footer">
        <button (click)="cancelar()" pRipple pButton class="p-button-outlined p-button-secondary flex justify-content-center ">
            CANCELAR
        </button>
        <button (click)="salvar()" pRipple pButton class="flex justify-content-center">
            CRIAR BLOQUEIO
        </button>
    </div>
</main>
